<template>
  <div
    v-if="buttonProps.text === undefined"
    class="navigation-button--text d-flex align-center cursor-pointer"
    :class="item.class"
    @click="clickAction"
  >
    <div class="px-4 navigation-button--text__content">
      {{ displayText }}
    </div>
  </div>
  <v-btn
    v-else
    :outlined="buttonProps.outlined"
    :color="buttonProps.color || null"
    :class="buttonProps.class"
    @click="clickAction"
  >
    {{ displayText }}
  </v-btn>
</template>

<script>
export default {
  name: 'NavigationButton',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonProps() {
      return this.item.buttonProps || {};
    },
    displayText() {
      return this.item.textKey ? this.$t(this.item.textKey) : this.item.text;
    }
  },
  methods: {
    clickAction() {
      if (this.buttonProps.clickAction) {
        this.buttonProps.clickAction();
        this.$emit('close');
        return;
      }
      // External link
      if (this.item.href) {
        window.location.href = this.item.href;
        this.$emit('close');
        return;
      }
      const currentPage = this.$router.history.current;
      const pageName = currentPage.name.split('___')[0];
      if (pageName === this.item.target) {
        this.$scrollTo(this.item.targetId, {
          offset: -110
        });
        this.gtmPush({
          event: 'button_click',
          link_location: `${this.item.targetId}`,
          link_text: `${this.item.text}`,
          'button.detail': 'menu'
        });
      } else {
        this.$router.push(
          this.$localePath({
            name: this.item.target,
            hash: this.item.targetId,
            query: this.$route.query,
            language: this.$i18n.locale
          })
        );
      }
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.navigation-button--text {
  height: 100%;
  font-size: $font-size-root;
  position: relative;

  &:focus,
  &:hover {
    .navigation-button--text__content {
      &::after {
        width: 100%;
        left: 0;
      }
    }
  }

  &__content {
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: $border-width;
      left: 50%;
      bottom: -$border-width;
      background-color: $primary;
      transition: all ease-in-out 0.2s;
    }
  }
}
</style>
